<template>
  <div class="course-classes-list">
    <CourseClassNavItem
      v-for="courseClass in courseClasses"
      :key="courseClass.id"
      :course-class="courseClass"
      @click="changeCourseModuleClassVideo(courseClass)"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import CourseClassNavItem from "@/components/course/course-class/CourseClassNavItem"

export default {
  components: {
    CourseClassNavItem
  },

  props: {
    courseClasses: { type: Array, required: true }
  },

  computed: {
    ...mapGetters("course", ["hasCourseAccess"])
  },

  methods: {
    ...mapMutations("course", ["setCourseModuleClass"]),

    changeCourseModuleClassVideo(courseClass) {     
      if (!courseClass.is_released) {
        return null
      }

      this.setCourseModuleClass(courseClass)
    }
  }
}
</script>

<style lang="scss" scoped>
.course-classes-list > *:not(:last-child) {
  margin-bottom: 8px
}
</style>
